import React, { useState } from 'react';
import { Body, Link } from '@grnhse/seedling/lib/birch/typography';
import { withLocalePrefix } from '../shared/utils/translation';
import { standardRequest } from '../shared/utils/request';
import { ErrorBody } from './styled_components';

const t = withLocalePrefix('authorization.authorization_form');

export type LoggedInAsProps = {
  name: string;
  email: string;
  organizationName: string;
  switchAccountUrl: string;
};

export const navigateTo = (url: string) => {
  window.location.assign(url);
};

export default function LoggedInAs({
  name,
  email,
  organizationName,
  switchAccountUrl,
}: LoggedInAsProps) {
  const [switchFailed, setSwitchFailed] = useState(false);

  const onSwitchAccount = async () => {
    setSwitchFailed(false);
    try {
      const { data } = await standardRequest.post<{ redirect_url: string }>(
        switchAccountUrl
      );
      navigateTo(data.redirect_url);
    } catch {
      setSwitchFailed(true);
    }
  };

  return (
    <>
      <Body>
        {t('logged_in_as', { name, email, organization: organizationName })}{' '}
        {t('not_you')}{' '}
        <Link onClick={onSwitchAccount}>{t('use_different_account')}</Link>
      </Body>
      {switchFailed && <ErrorBody>{t('switch_account_error')}</ErrorBody>}
    </>
  );
}
